import { render, staticRenderFns } from "./AddCollectionModal.vue?vue&type=template&id=43c6a468&scoped=true"
import script from "./AddCollectionModal.vue?vue&type=script&lang=js"
export * from "./AddCollectionModal.vue?vue&type=script&lang=js"
import style0 from "./AddCollectionModal.vue?vue&type=style&index=0&id=43c6a468&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./AddCollectionModal.vue?vue&type=style&index=2&id=43c6a468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c6a468",
  null
  
)

export default component.exports